export default {
    computed: {
        categoryJsonldScript() {
            const baseUrl = `https://${this.$config.website.domain}`;
            const pageUrl = `${baseUrl}/catalog/${this.slug || this.treeId}`;

            let schema = null;

            if (this.hasChilds && this.categories?.length) {
                schema = {
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    url: pageUrl,
                    name: this.name,
                    mainEntity: {
                        "@type": "ItemList",
                        numberOfItems: this.categories.length,
                        itemListElement: this.categories.map((cat, i) => ({
                            "@type": "ListItem",
                            position: i + 1,
                            item: {
                                "@type": "CollectionPage",
                                url: `${baseUrl}${this.getCategoryLink(cat)}`,
                                name: cat.name,
                                ...(cat.photo && { image: cat.photo }),
                            }
                        }))
                    }
                };
            } else if (this.products?.length) {
                schema = {
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    url: pageUrl,
                    name: this.name,
                    mainEntity: {
                        "@type": "ItemList",
                        numberOfItems: this.products.length,
                        itemListElement: this.products.map((product, i) => ({
                            "@type": "ListItem",
                            position: i + 1,
                            item: {
                                "@type": "Product",
                                url: `${baseUrl}${this.getProductLink(product)}`,
                                name: product.name,
                                sku: product.id,
                                brand: {
                                    "@type": "Brand",
                                    name: this.$config.website.name,
                                },
                                ...(product.photo && { image: product.photo }),
                            }
                        }))
                    }
                };
            }

            if (!schema) return null;

            return {
                hid: "category-jsonld",
                type: "application/ld+json",
                innerHTML: JSON.stringify(schema),
            };
        },
    },
};
